'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: 20px;\n  '], ['\n    padding: 20px;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UITile = require('UIComponents/tile/UITile');

var _UITile2 = _interopRequireDefault(_UITile);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTile = (0, _styledComponents2.default)(_UITile2.default).withConfig({
  displayName: 'CalculatorPlanSelectorTile__StyledTile'
})(['padding:55px;min-height:600px;height:100%;width:640px;', ';', ''], _responsiveBreakpoints2.default.tablet(_templateObject), _responsiveBreakpoints2.default.phone(_templateObject2));

var CalculatorPlanSelectorTile = function CalculatorPlanSelectorTile(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    StyledTile,
    null,
    children
  );
};

exports.default = CalculatorPlanSelectorTile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/CalculatorPlanSelectorTile.js
// module id = 735
// module chunks = 3 4